// extracted by mini-css-extract-plugin
export default {"body":"PasswordRecoveryScreen_body__mV25m"};